export enum RolePermissions {
    MASTER = 1,
    FUNCIONARIO = 18
}
